/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 */ // $FlowFixMe
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { NativeModules, NativeEventEmitter } from "react-native";
var Flipper = NativeModules.Flipper;
export default Flipper;
var listeners = {}; // plugin#method -> callback
var plugins = {}; // plugin -> Plugin
function assertSerializable(data) {
    if (data === undefined || Array.isArray(data) || data && typeof data === "object") {
        return true;
    }
    throw new Error("Flipper: Expected serializable (undefined, an array or an object). Got: " + data);
}
var Connection = /*#__PURE__*/ function() {
    "use strict";
    function Connection(pluginId) {
        _class_call_check(this, Connection);
        _define_property(this, "connected", void 0);
        _define_property(this, "pluginId", void 0);
        this.connected = false;
        this.pluginId = pluginId;
    }
    _create_class(Connection, [
        {
            key: "send",
            value: function send(method, data) {
                if (!this.connected) {
                    throw new Error("Cannot send data, not connected");
                }
                assertSerializable(data);
                Flipper.send(this.pluginId, method, JSON.stringify(data));
            }
        },
        {
            key: "reportErrorWithMetadata",
            value: function reportErrorWithMetadata(reason, stackTrace) {
                Flipper.reportErrorWithMetadata(this.pluginId, "" + reason, "" + stackTrace);
            }
        },
        {
            key: "reportError",
            value: function reportError(error) {
                Flipper.reportError(this.pluginId, "" + error);
            }
        },
        {
            key: "receive",
            value: function receive(method, listener) {
                if (!this.connected) {
                    throw new Error("Cannot receive data, not connected");
                }
                listeners[this.pluginId + "#" + method] = listener;
                Flipper.subscribe(this.pluginId, method);
            }
        }
    ]);
    return Connection;
}();
var Responder = /*#__PURE__*/ function() {
    "use strict";
    function Responder(responderId) {
        _class_call_check(this, Responder);
        _define_property(this, "responderId", void 0);
        this.responderId = responderId;
    }
    _create_class(Responder, [
        {
            key: "success",
            value: function success(response) {
                assertSerializable(response);
                Flipper.respondSuccess(this.responderId, response == null ? null : JSON.stringify(response));
            }
        },
        {
            key: "error",
            value: function error(response) {
                assertSerializable(response);
                Flipper.respondError(this.responderId, JSON.stringify(response));
            }
        }
    ]);
    return Responder;
}();
function startEventListeners() {
    var emitter = new NativeEventEmitter(Flipper);
    emitter.addListener("react-native-flipper-plugin-connect", function(event) {
        var plugin = event.plugin;
        if (plugins[plugin]) {
            var p = plugins[plugin];
            p._connection.connected = true;
            p.onConnect(p._connection);
        }
    });
    emitter.addListener("react-native-flipper-plugin-disconnect", function(event) {
        var plugin = event.plugin;
        if (plugins[plugin]) {
            var p = plugins[plugin];
            p._connection.connected = false;
            p.onDisconnect();
        }
    });
    emitter.addListener("react-native-flipper-receive-event", function(event) {
        var plugin = event.plugin, method = event.method, params = event.params, responderId = event.responderId;
        var key = plugin + "#" + method;
        if (listeners[key]) {
            var responder = responderId != null ? new Responder(responderId) : undefined;
            listeners[key](JSON.parse(params), responder);
        }
    });
}
// $FlowFixMe
export function addPlugin(plugin) {
    if (!Flipper) {
        printNoFlipperWarning();
        return;
    }
    if (!plugin || typeof plugin !== "object") {
        throw new Error("Expected plugin, got " + plugin);
    }
    [
        "getId",
        "onConnect",
        "onDisconnect"
    ].forEach(function(method) {
        if (typeof plugin[method] !== "function") {
            throw new Error("Plugin misses an implementation for '".concat(method, "'"));
        }
    });
    var runInBackground = typeof plugin.runInBackground === "function" ? !!plugin.runInBackground() : false;
    var id = plugin.getId();
    plugin._connection = new Connection(id);
    plugins[id] = plugin;
    Flipper.registerPlugin(id, runInBackground, function(status) {
        if (status === "noflipper") {
            printNoFlipperWarning();
        }
    });
}
function printNoFlipperWarning() {
    // $FlowFixMe
    if (typeof __DEV__ !== "undefined" && __DEV__) {
        console.warn("The native module for Flipper seems unavailable. Please verify that `react-native-flipper` is installed as yarn dependency to your project and, for iOS, that `pod install` is run in the `ios` directory.");
    }
}
if (Flipper) {
    startEventListeners();
}
